
import HomeWifi from "../../../assets/outline/HomeWifi.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HomeWifiIcon({ className, dataTestid = "HomeWifiIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HomeWifi data-testid={dataTestid} className={classes} {...rest} />
  );
}
